import { ROUTES, TITLES, PROD, DEV, STAGE } from 'consts';

export const TIMESHEET_MENU = {
  key: ROUTES.TIMESHEET.ROOT,
  label: TITLES[ROUTES.TIMESHEET.ROOT],
  environment: [DEV, STAGE, PROD],
  children: [
    {
      key: ROUTES.TIMESHEET.APARTMENTS,
      label: TITLES[ROUTES.TIMESHEET.APARTMENTS],
      environment: [DEV, STAGE, PROD],
    },
    {
      key: ROUTES.TIMESHEET.ENG_NETWORKS,
      label: TITLES[ROUTES.TIMESHEET.ENG_NETWORKS],
      environment: [DEV, STAGE, PROD],
    },
  ],
};
